export enum ClipboardMessages {
  Error = 'common.copy_to_clipboard.error',
  Info = 'common.copy_to_clipboard.info',
  Success = 'common.copy_to_clipboard.success',
}
